import React from 'react';

import { cn } from 'DesignSystem/utils';

import { isEmptyRichHtml, sanitizeRichHtml } from './sanitize-rich-html';

export const richHtmlClassName = cn(
  'text-sm leading-6 text-zinc-900',
  '[&_p:last-child]:mb-0 [&_p]:mb-3',
  '[&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-6',
  '[&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:pl-6',
  '[&_li]:my-1',
  '[&_a]:text-blue-600 [&_a]:underline'
);

type RichHtmlProps = {
  html?: string | null;
  className?: string;
  emptyLabel?: string;
};

export function RichHtml({ html, className, emptyLabel }: RichHtmlProps) {
  const sanitized = sanitizeRichHtml(html);

  if (isEmptyRichHtml(sanitized)) {
    if (!emptyLabel) return null;
    return <p className={cn('text-sm text-zinc-500', className)}>{emptyLabel}</p>;
  }

  return <div className={cn(richHtmlClassName, className)} dangerouslySetInnerHTML={{ __html: sanitized }} />;
}
